let apiUrl = '';
let middlewareUrl = '';

if (process.env.NODE_ENV === 'development') {
  apiUrl = 'http://192.168.56.101';
  middlewareUrl = 'http://nav.post';
} else if (process.env.NODE_ENV === 'production') {
  apiUrl = 'http://tilauksetvermanfi.tunkki.mysteer.io/api';
  middlewareUrl = 'http://tilauksetvermanfi.tunkki.mysteer.io/nav-middleware/';
  if (process.env.REACT_APP_TESTING_SERVER) {
    apiUrl = 'https://tilaukset.update1.mysteer.io/api';
    middlewareUrl = 'https://tilaukset.update1.mysteer.io/nav-middleware/';
  }
}

if (process.env.REACT_APP_ENV) {
  apiUrl = 'http://tilaussovellus-react.dev.mysteer.io/api';
  middlewareUrl = 'http://tilaussovellus-react.dev.mysteer.io/nav-middleware';
}

export const API_URL_MIDDLEWARE = middlewareUrl;
export const API_URL = apiUrl;

export const PRODUCT_STORE = 'ProductStore';
export const CART_STORE = 'CartStore';
export const CUSTOMER_STORE = 'CustomerStore';
export const ORDER_FORM_STORE = 'OrderFormStore';
export const NOTIFICATION_STORE = 'NotificationStore';
export const AUTH_STORE = 'AuthStore';
export const ORDER_TYPES_STORE = 'OrderTypesStore';
export const COMPANY_STORE = 'CompanyStore';
export const FEEDBACK_STORE = 'FeedbackStore';
export const MODAL_STORE = 'ModalStore';
export const ORDER_HISTORY_STORE = 'OrderHistoryStore';
export const FILTER_STORE = 'FilterStore';

export const DATE_FORMAT = 'YYYY-MM-DD';

// tslint:disable-next-line:max-line-length
export const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const VERMAN_BRANDS = ['Sorbact', 'Smartlax', 'Rela', 'Lactrase', 'Ramavit',
  'Minisun', 'Wonderm', 'Bethover', 'Helein', 'Synomax', 'Melarest'];

export const BIOTEEKKI_BRANDS = ['Super', 'Teho', 'Probiootti', 'Dentiplus', 'Elinvoima', 'KP',
  'Omega', 'Unia'];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/constants.ts